import {AppDispatch} from '../store';
import {getJsonData} from './requests';

export const getAllSeasons = (dispatch: AppDispatch) => {
    const url = 'api/1.0/seasons';
    return getJsonData(url, dispatch);
};